export const DAYS = [['mon','Monday'],['tue','Tuesday'],['wed','Wednesday'],['thu','Thursday'],['fri','Friday'],['sat','Saturday'],['sun','Sunday']];

export const WINDOWS = [['06_14','6 AM–2 PM'],['14_22','2 PM–10 PM'],['22_06','10 PM–6 AM'],['07_19','7 AM–7 PM'],['06_18','6 AM–6 PM'],['18_06','6 PM–6 AM'],['19_07','7 PM–7 AM']];

export const emptySchedule = () => Object.fromEntries(DAYS.map(([day]) => [day, []]));

export function normalizeSchedule(schedule) {

  if (!schedule || typeof schedule !== 'object' || Array.isArray(schedule)) return null;

  const result = emptySchedule();

  for (const [day] of DAYS) {

    if (!Array.isArray(schedule[day])) return null;

    const values = schedule[day].map(value => typeof value === 'string' ? value.replace('-', '_') : value);

    if (values.some(value => !WINDOWS.some(([key]) => key === value))) return null;

    result[day] = WINDOWS.map(([key]) => key).filter(key => values.includes(key));

  }

  return result;

}

// Advisory only. Null means unknown; never use it to grant assignment permission.

// Explicit facility timezone avoids treating the browser's timezone as authoritative.

export function isWorkerAvailableForShift(worker, shift, timeZone) {

  const schedule = resolveAvailabilitySchedule(worker).schedule;

  if (!schedule || !timeZone || shift?.isFlexibleTime || shift?.flexibleEmergency || shift?.coverageType === "emergency_fill") return null;

  try {

    const date = value => value?.toDate ? value.toDate() : new Date(value);

    if (shift?.startTime == null || shift?.endTime == null) return null;

    const start = date(shift.startTime), end = date(shift.endTime);

    if (!(end > start) || end - start > 25 * 3600000) return null;

    const formatter = new Intl.DateTimeFormat('en-US', { timeZone, weekday:'short', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23' });

    const parts = date => Object.fromEntries(formatter.formatToParts(date).map(p => [p.type,p.value]));

    const a = parts(start), b = parts(end);

    if (a.minute !== '00' || b.minute !== '00' || a.second !== '00' || b.second !== '00') return null;

    const key = `${a.hour}_${b.hour}`;

    if (!WINDOWS.some(([id]) => id === key)) return null;

    const dayIndex = DAYS.findIndex(([day]) => day === a.weekday.toLowerCase());

    const nextDay = DAYS[(dayIndex + (Number(b.hour) <= Number(a.hour) ? 1 : 0)) % 7][0];

    if (b.weekday.toLowerCase() !== nextDay) return false;

    return schedule[a.weekday.toLowerCase()].includes(key);

  } catch (_) { return null; }

}


// Only explicit day + exact window legacy combinations can be safely previewed.
export function resolveAvailabilitySchedule(worker = {}) {
  if (worker.availabilitySchedule != null) return { schedule: normalizeSchedule(worker.availabilitySchedule), source: 'canonical' };
  const old = worker.availability || {};
  const days = Array.isArray(worker.availableDays) ? worker.availableDays : worker.preferredDays;
  const shifts = worker.availableShifts || worker.preferredShifts || old.shifts;
  if (!Array.isArray(shifts)) return { schedule: null, source: 'missing' };
  const selected = Array.isArray(days) ? days.map(day => String(day).slice(0,3).toLowerCase()) : DAYS.filter(([,label]) => old[label.toLowerCase()] === true).map(([day]) => day);
  if (!selected.length || selected.some(day => !DAYS.some(([key]) => key === day))) return { schedule: null, source: 'missing' };
  const schedule = emptySchedule();
  selected.forEach(day => { schedule[day] = shifts; });
  return { schedule: normalizeSchedule(schedule), source: 'legacy' };
}
